import { render, staticRenderFns } from "./channels-stores-form-wrapper.vue?vue&type=template&id=51159755"
import script from "./channels-stores-form-wrapper.vue?vue&type=script&lang=js"
export * from "./channels-stores-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports